import { getString } from "config-api";

export const CONTROL_PANEL_KVP_ENDPOINT = `${getString(
    "Client.contentApi.baseURL"
)}key-values`;

export const FEATURE_FLAG = "ocelot.feature";
export const FLP_FLAG = "ocelot.flp";
